import React, { useState } from "react";
import { Box, Typography, Modal, Fab } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import App from "./App";

const AppWithModal = () => {
  const [open, setOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsExpanded(false);
  };
  const handleToggle = () => setOpen(!open);
  const handleToggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <>
      {/* Mock main website background */}
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          backgroundColor: "#f5f5f5",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
        }}
      >
        <Typography variant="h2" color="textPrimary">
          Mock-up
        </Typography>
      </Box>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="chat"
        onClick={handleToggle}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          backgroundColor: "#1A5632",
          "&:hover": {
            backgroundColor: "#145028",
          },
          width: 64,
          height: 64,
          zIndex: 9999,
        }}
      >
        <FontAwesomeIcon icon={faComments} size="2x" />
      </Fab>

      {/* Chat Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isExpanded ? "center" : "flex-end",
          padding: isExpanded ? 0 : 3,
        }}
      >
        {/* 420 x 730 aspect ratio */}
        <Box
          sx={{
            height: isExpanded ? "100vh" : "80vh",
            aspectRatio: isExpanded ? "auto" : "420 / 730",
            width: isExpanded ? "100vw" : "auto",
            maxWidth: isExpanded ? "100vw" : "90vw",
            backgroundColor: "white",
            borderRadius: isExpanded ? 0 : "8px",
            boxShadow: 24,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <App onClose={handleClose} onToggleExpand={handleToggleExpand} isExpanded={isExpanded} />
        </Box>
      </Modal>
    </>
  );
};

export default AppWithModal;
